export function isNullOrWhitespace(input) {
    return !input || !input.trim();
}
//# sourceMappingURL=isNullOrWhitespace.js.map